import { render } from "./WelcomeBanner.vue?vue&type=template&id=5f394ec6&scoped=true"
import script from "./WelcomeBanner.vue?vue&type=script&lang=js"
export * from "./WelcomeBanner.vue?vue&type=script&lang=js"

import "./WelcomeBanner.vue?vue&type=style&index=0&id=5f394ec6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f394ec6"]])

export default __exports__